import { useSelector, useDispatch, useStore } from "react-redux";
import { Api } from "../uikit/service/api";
import func from "@uikit/func";
import { fotActions } from "../store/fot";
import { useEffect, useRef, useState } from "react";

export default function useOpenAiToGenerate() {
  const store = useStore();
  const dispatch = useDispatch();
  const api = new Api(false);

  const [openaiLoading, setOpenaiLoading] = useState(false);
  const [hcTag1Completed, setHcTag1Completed] = useState(false);
  const [hcTag1Result, setHcTag1Result] = useState([]);
  const [hcTag2Completed, setHcTag2Completed] = useState(false);
  const [hcTag2Result, setHcTag2Result] = useState([]);

  const focusedThought = useSelector(state => state.feed.focusedThought);
  const contentLoading = useSelector(state => state.fot.contentLoading);
  const errorState = useSelector(state => state.fot.errorState);

  // const openAiTextData = useSelector((state) => state.fot.openAiTextData);
  const setOpenAiTextData = val => {
    dispatch(fotActions.setOpenAiTextData(val));
  };

  const handleDataHCTag1 = text => {
    const textArr = text.split("\n\n");
    const numStartReg = /^[0-9]/;
    const filterTextArr = textArr.filter(x => {
      return (
        x.includes("Why the idea might be good:") ||
        x.includes("Challenge the idea:") ||
        x.includes("How to pivot based on the challenge:") ||
        numStartReg.test(x)
      );
    });
    const newTextArr = [];

    filterTextArr.forEach(x => {
      const arr = x.split(":");
      const title = arr[0]?.trim() || "";
      const value = arr[1]?.trim() || "";
      const findObj = newTextArr.find(x => x.title === "Challenge the idea");

      if (numStartReg.test(x)) {
        if (func.isEmpty(findObj)) return;
        findObj.subthought.value.push(x.replace(/^\d\.\s?/, ""));
        return;
      }
      if (title === "How to pivot based on the challenge") {
        if (func.isEmpty(findObj)) return;
        findObj.subthought = {
          title,
          value: [],
        };
        return;
      }
      newTextArr.push({
        type: "openai",
        title,
        value,
      });
    });
    return newTextArr;
  };

  const handleDataHCTag2 = text => {
    const textArr = text.split("\n");
    const numStartReg = /^[0-9]+/;
    const filterTextArr = textArr.filter(x => numStartReg.test(x));
    const ugcBlockObj = {
      type: "openai",
      title: "Questions investors might ask",
      value: null,
      subthought: {
        title: null,
        value: [],
      },
    };
    filterTextArr.forEach(x => {
      if (numStartReg.test(x)) {
        ugcBlockObj.subthought.value.push(x.replace(/^\d+\.\s?/, ""));
      }
    });
    return [ugcBlockObj];
  };

  const openAiRequestList = [
    {
      getPrompt: query => {
        return `The system expands on detailed thinking of how to build a company based on a company idea.\n###\nCompany idea: I want to build a web product that combines Miro board and Figma into one tool.\n\nWhy the idea might be good: Figma is a cloud-based design tool that focuses on collaborative design while Miro is a cloud-based collaboration visual board that focuses more on ideation collaborations, it might be a good idea to merge the two considering the collaborative nature of both tools. Another reason why this could be a good idea is that generative AI can be used to turn some of the collaboration ideas on Miro board into actual designs with generative AI technology. This will increase the efficiency of such collaboration dramatically and create a truly magical experience.\n\nChallenge the idea: Figma is implementing new beta products like FigJam that could turn into something similar to Miro board. This could hurt the feasibility of your product considering they already have 4 million active users. FigJam is a free online whiteboarding and collaboration tool you and your team can use to brainstorm and organize ideas.\n\nHow to pivot based on the challenge: I would focus on the features neither of these platforms already has such as generative AI considering how new the technology is. You can unleash your imagination on how to apply generative AI to your platform. When it comes to the collaborative brainstorming board, users can not only collaborate with one another, but the machine can also expand upon the flow of thought and continue to ideate to create this magical new experience of human-machine collaboration.\n\nNew pivoted ideas:\n\n1. Focus on applying generative AI technology to the product to help teams and individuals ideate and design better.\n\n2. Utilize generative AI to expand on user ideas, which can be visualized in the Miro board and further edited on Figma.\n\n3. Offer additional features like video conferencing, audio recording, and task management, to further enhance the user experience.\n\n###\nCompany idea:${query}`;
      },
      hcTag: 1,
      handler: handleDataHCTag1,
      ref: useRef(null),
      completed: hcTag1Completed,
      result: hcTag1Result,
      setCompleted: setHcTag1Completed,
      setResult: setHcTag1Result,
    },
    {
      getPrompt: query => {
        return `"The system lists possible questions that are specific to the business idea a sophisticated investor might ask an entrepreneur based on his business idea.\nBusiness idea:${query}\nQuestions:"`;
      },
      hcTag: 2,
      handler: handleDataHCTag2,
      ref: useRef(null),
      completed: hcTag2Completed,
      result: hcTag2Result,
      setCompleted: setHcTag2Completed,
      setResult: setHcTag2Result,
    },
  ];

  const postOpenAi = (self, query) => {
    let prompt = "";
    if (typeof self.getPrompt === "function") {
      prompt = self.getPrompt(query);
    }
    const data = {
      api: "completions",
      engine: "text-davinci-003",
      frequency_penalty: 0,
      max_tokens: 380,
      top_p: 0.7,
      presence_penalty: 0,
      stop: [],
      prompt: prompt,
    };
    self.setCompleted(false);
    self.setResult([]);
    setOpenaiLoading(true);

    self.ref.current = api.postWithErrorCanAbort("/be/bas-demo-v4/nlp/brain_openai", data);
    self.ref.current
      .then(res => {
        if (func.isEmpty(res?.data?.choices?.[0]?.text)) return;
        const text = res.data.choices[0].text;
        let newTextArr = [];
        if (typeof self.handler === "function") {
          newTextArr = self.handler(text);
        }
        self.setCompleted(true);
        self.setResult(newTextArr);
        // new thought比openai请求先完成执行
        const focusedThoughtObj = store.getState().feed.focusedThought;
        if (
          !store.getState().fot.contentLoading &&
          focusedThoughtObj.hc_tag === self.hcTag &&
          func.isEmpty(store.getState().fot.openAiTextData[focusedThoughtObj.thought])
        ) {
          setOpenAiTextData({
            thought: focusedThoughtObj.thought,
            value: newTextArr,
          });
        }
      })
      .catch(error => {
        self.setCompleted(true);
        if (error.constructor === DOMException && error.name === "AbortError") {
          return;
        }
        console.error("postOpenAi", error);
      })
      .finally(() => {
        const focusedThoughtObj = store.getState().feed.focusedThought;
        if (focusedThoughtObj.hc_tag === self.hcTag) {
          setOpenaiLoading(false);
        }
      });
  };

  useEffect(() => {
    const openAiTextData = store.getState().fot.openAiTextData;

    // new thought比openai请求后完成执行
    if (!contentLoading) {
      const requestMatchesHcTag = openAiRequestList.find(x => x.hcTag === focusedThought.hc_tag);
      // only set loading to false and set result if the request matching hc tag is completed
      if (errorState || !requestMatchesHcTag || requestMatchesHcTag.completed) {
        setOpenAiTextData({
          thought: focusedThought.thought,
          value: requestMatchesHcTag?.result || [],
        });
        setOpenaiLoading(false);
      }
      // check if there's no longer a need to call openai
      openAiRequestList.forEach(request => {
        if (errorState || request.hcTag !== focusedThought.hc_tag) {
          // abort openAi request
          request.ref.current?.cancel?.();
        }
      });
      return;
    }
    // TODO: need to revisitd david
    if (contentLoading && func.isEmpty(openAiTextData[focusedThought.thought])) {
      // execute multiple openAI calls for different prompt according to different hc_tag
      openAiRequestList.map(each => {
        postOpenAi(each, focusedThought.thought);
      });
    }
  }, [contentLoading]);

  return {
    openaiLoading,
  };
}
